export default {
  methods: {
    getPolygon: function(x, y, polygon, size) {
      size = size || 1
      polygon = polygon || []
      x = x || 0
      y = y || 0
      let res = []
      polygon.forEach(el => {
        res.push([x + el[0] * size, y + el[1] * size])
      })
      return res
    },
  },
  objects: {
    /**
     * Фигура самолета
     */
    plane: [
      [0, -14],
      [-5, -15],
      [-5, -13],
      [-1, -11],
      [-2, -8],
      [-2, -3],
      [-5, -3],
      [-15, -7],
      [-15, -3],
      [-2, 5],
      [-2, 14],
      [-1, 16],
      [0, 17],
      [1, 16],
      [2, 14],
      [2, 5],
      [15, -3],
      [15, -7],
      [5, -3],
      [2, -3],
      [2, -8],
      [1, -11],
      [5, -13],
      [5, -15],
    ],
    /**
     * Фигура стоянки
     */
    stand: [[0, 4], [6, 2], [6, -2], [0, -4], [-6, -2], [-6, 2]],
  },
}
